import React, { useState, useEffect } from 'react';
import '../ExamPaperdetailInfo/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { Link } from "react-router-dom";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';

function ExamPaperdetailInfoList() {
    const [overviewList, setOverviewList] = useState([]);

    useEffect(() => {
        fetchOverviews();
    }, []);

    const fetchOverviews = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getAdminExamPreparationExamInfo`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });
            setOverviewList(response.data);
        } catch (err) {
            console.error("Error fetching overviews:", err);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/deleteExamPreparationExamInfoById/${id}`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                setOverviewList(overviewList.filter((item) => item.id !== id));
            }
        } catch (error) {
            console.error("Error deleting overview:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Exam Paper Detail Info List</h1>
                            <Link className="recent-Articles add-button" to={`/admin/createExamPaperdetailInfo`}>
                                + Create Paper Detail info
                            </Link>
                        </div>

                        <div className="report-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Heading</th>
                                        <th>Info title</th>
                                        <th>Title</th>
                                        <th>Description</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {overviewList.length > 0 ? (
                                        overviewList.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.title}</td>
                                                <td>{item.heading}</td>
                                                <td>{item.exam_title}</td>
                                                <td dangerouslySetInnerHTML={{ __html: item.overview_description }} />
                                                <td>{item.status == 1 ? "Active" : "Inactive"}</td>
                                                <td>
                                                    <Link to={`/admin/editExamPaperdetailInfo/${item.id}`}>
                                                        <i
                                                            className="fa fa-pencil"
                                                            style={{ color: "#007bff", marginRight: "10px", cursor: "pointer" }}
                                                        />
                                                    </Link>
                                                    <span
                                                        style={{ color: "red", cursor: "pointer" }}
                                                        onClick={() => handleDelete(item.id)}
                                                    >
                                                        <i className="fa fa-trash-o" style={{ marginRight: 5 }} />
                                                        Delete
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExamPaperdetailInfoList;
